import { Routes, Route, Navigate } from "react-router-dom";
import Index from "@/pages/Index";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ErrorPage from "@/pages/ErrorPage";
import ComingSoon from "@/pages/ComingSoon";
import ComingSoonEs from "@/pages/ComingSoonEs";
import ComingSoonCa from "@/pages/ComingSoonCa";
import MatchList from "@/pages/MatchList";
import PostMatch from "@/pages/PostMatch";
import MatchDetails from "@/pages/MatchDetails";
import UserProfile from "@/pages/UserProfile";
import Settings from "@/pages/Settings";
import WalletStatement from "@/pages/WalletStatement";
import Notifications from "@/pages/Notifications";
import CompleteRegistration from "@/pages/CompleteRegistration";
import GoalkeeperProfile from "@/pages/GoalkeeperProfile";
import { PrivateRoute } from "@/components/auth/PrivateRoute";

const isDevelopment = import.meta.env.DEV;

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/error" element={<ErrorPage errorCode={404} />} />
      
      {/* Language-prefixed Coming Soon routes */}
      <Route path="/en/coming-soon" element={<ComingSoon />} />
      <Route path="/es/coming-soon" element={<ComingSoonEs />} />
      <Route path="/ca/coming-soon" element={<ComingSoonCa />} />

      {/* Legacy routes - will redirect to new routes */}
      <Route path="/coming-soon" element={<Navigate to="/en/coming-soon" replace />} />
      <Route path="/coming-soon-en" element={<Navigate to="/en/coming-soon" replace />} />
      <Route path="/coming-soon-es" element={<Navigate to="/es/coming-soon" replace />} />
      <Route path="/coming-soon-ca" element={<Navigate to="/ca/coming-soon" replace />} />

      {/* Development routes */}
      {isDevelopment ? (
        <>
          <Route path="/" element={<Index />} />
          <Route path="/matches" element={<MatchList />} />
          <Route path="/post-match" element={<PostMatch />} />
          <Route path="/match/:id" element={<MatchDetails />} />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <UserProfile />
              </PrivateRoute>
            }
          />
          <Route path="/settings" element={<Settings />} />
          <Route path="/wallet" element={<WalletStatement />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/complete-registration" element={<CompleteRegistration />} />
          <Route path="/goalkeeper-profile/:id" element={<GoalkeeperProfile />} />

          {/* Keep dev prefixed routes for backward compatibility */}
          <Route path="/dev" element={<Index />} />
          <Route path="/dev/matches" element={<MatchList />} />
          <Route path="/dev/post-match" element={<PostMatch />} />
          <Route path="/dev/match/:id" element={<MatchDetails />} />
          <Route
            path="/dev/profile"
            element={
              <PrivateRoute>
                <UserProfile />
              </PrivateRoute>
            }
          />
          <Route path="/dev/settings" element={<Settings />} />
          <Route path="/dev/wallet" element={<WalletStatement />} />
          <Route path="/dev/notifications" element={<Notifications />} />
          <Route path="/dev/complete-registration" element={<CompleteRegistration />} />
          <Route path="/dev/goalkeeper-profile/:id" element={<GoalkeeperProfile />} />
        </>
      ) : (
        // Redirect to Coming Soon in production
        <Route path="*" element={<Navigate to="/es/coming-soon" replace />} />
      )}
    </Routes>
  );
};

export default AppRoutes;
